import { BaseEntity } from "yt-ng-framework";

export class TekuceEkranskiPregledKomitenata extends BaseEntity{
    constructor()
    {super();}

    BrojDokumenta: string;
    TekuceDuguje: number;
    TekucePotrazuje: number;
    TekuceUkupno: number;
    Komitent: string;
    DatumDokumenta: Date;
    OrgJed: string;

    Deserialize(input: any){
        this.BrojDokumenta = input.BrojDokumenta;
        this.TekuceDuguje = input.TekuceDuguje;
        this.TekucePotrazuje = input.TekucePotrazuje;
        this.TekuceUkupno = input.TekuceUkupno;
        this.Komitent = input.Komitent;
        this.DatumDokumenta = input.DatumDokumenta;
        this.OrgJed = input.OrgJed;
        return this;
    }

    Serialize(input: TekuceEkranskiPregledKomitenata): {} {
        return input;
    }
}